function detectPairingCode() {
    var pairingCode = window.location.search.replace('?','') || null;

    setTimeout(function() {
        $("center").fadeIn();
    }, 5000);

    switch (getMobileOperatingSystem()) {
        case "android":
            openAndroidApp(pairingCode);
            break;
        case "ios":
            openIOSApp(pairingCode);
            break;
        default:
            window.location = `${process.env.UBX_TRAINING_URL}/train-app.html`;
            break;
    }
}

function getMobileOperatingSystem() {

    var userAgent = navigator.userAgent || navigator.vendor || window.opera;
      // Windows Phone must come first because its UA also contains "Android"
    if (/windows phone/i.test(userAgent)) {
        return "other";
    }

    if (/android/i.test(userAgent)) {
        return "android";
    }

    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        return "ios";
    }

    return "other";
}


function openAndroidApp(pairingCode) {

    var custom = "trainondemand://pairing";

    var alt = "https://play.google.com/store/apps/details?id=com.trubx.train";
    var g_intent = "intent://scan/#Intent;scheme=zxing;package=com.trubx.train;end";

    var timer;
    var heartbeat;
    var iframe_timer;

    function clearTimers() {
        clearTimeout(timer);
        clearTimeout(heartbeat);
        clearTimeout(iframe_timer);
    }

    function intervalHeartbeat() {
        if (document.webkitHidden || document.hidden) {
            clearTimers();
        }
    }

    function tryIframeApproach() {
        var iframe = document.createElement("iframe");
        iframe.style.border = "none";
        iframe.style.width = "1px";
        iframe.style.height = "1px";
        iframe.onload = function () {
            document.location = alt;
        };
        iframe.src = custom;
        document.body.appendChild(iframe);
    }

    function tryWebkitApproach() {
        document.location = custom;
        timer = setTimeout(function () {
            document.location = alt;
        }, 2500);
    }

    function useIntent() {
        document.location = g_intent;
    }

    function launch_app_or_alt_url() {
        heartbeat = setInterval(intervalHeartbeat, 200);
        if (navigator.userAgent.match(/Chrome/)) {
            useIntent();
        } else if (navigator.userAgent.match(/Firefox/)) {
            tryWebkitApproach();
            iframe_timer = setTimeout(function () {
                tryIframeApproach();
            }, 1500);
        } else {
            tryIframeApproach();
        }
    }
    launch_app_or_alt_url();

}


function openIOSApp(pairingCode) {

    var appUrlScheme;

    if(pairingCode) {
        appUrlScheme = `trainondemand://pairing/${pairingCode}`;
    } else {
        appUrlScheme = 'trainondemand://pairing';
    }

    // If the app is not installed the script will wait for 2sec and redirect to web.
    var loadedAt = +new Date;
    setTimeout(function() {
        if (+new Date - loadedAt < 3000)
            console.log("App not yet installed");
            document.location = 'https://apps.apple.com/au/app/train-on-demand/id1505678506';
    } ,25);
    // Try launching the app using URL schemes
    setTimeout(function(){
        window.open(appUrlScheme, "_self");
    }, 1000);

}

export { detectPairingCode }